import React, { useEffect, useState } from 'react';
import Subscription from '../../types/Subscription';
import Button from '../Button/Button';

export default function SubscribeButtons({
  label = 'Sign up',
}: {
  label?: string;
}) {
  const [subscriptions, setSubscriptions] = useState([] as Subscription[]);
  const [publishableKey, setPublishableKey] = useState(
    undefined as string | undefined
  );

  useEffect(() => {
    async function getPublishableKey() {
      const getPublishableKeyResponse = await fetch(
        '/api/Checkout/GetPublishableKey'
      );
      setPublishableKey(await getPublishableKeyResponse.text());
    }
    getPublishableKey();
  }, []);

  useEffect(() => {
    async function getSubscriptions() {
      const subscriptionResponse = await fetch('/api/Checkout/ListProducts');
      setSubscriptions(await subscriptionResponse.json());
    }
    getSubscriptions();
  }, []);

  if (!publishableKey) {
    return <Button variant={'primary'}>Loading...</Button>;
  }

  return (
    <>
      {subscriptions.map((s) => {
        return (
          <Button
            key={s.id}
            tag={'Link'}
            variant={'primary'}
            to={`/api/Checkout/CreateSession/${s.defaultPrice}`}
          >
            {label}
          </Button>
        );
      })}
    </>
  );
}
